import { Search, FileText, BarChart3, HelpCircle } from "lucide-react";
import { SectionWrapper } from "@/components/ui/section-wrapper";

const painPoints = [
  {
    icon: Search,
    title: "SEO is confusing and time-consuming",
    description: "Meta tags, keywords, alt text... where do you even start?",
  },
  {
    icon: FileText,
    title: "Product descriptions sit outdated for months",
    description: "You know they need updating, but who has the time?",
  },
  {
    icon: BarChart3,
    title: "Analytics are scattered across 5 different plugins",
    description: "Getting a clear picture of your store's health is a nightmare.",
  },
  {
    icon: HelpCircle,
    title: "You know you should optimize, but where do you start?",
    description: "There's always something more urgent than SEO improvements.",
  },
];

export function ProblemSection() {
  return (
    <SectionWrapper variant="muted">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
          Running a store shouldn't feel like a second job
        </h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Sound familiar? You're not alone.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {painPoints.map((point, index) => (
          <div
            key={index}
            className="group p-6 rounded-xl bg-card border border-border hover:border-primary/50 hover:shadow-lg transition-all duration-300"
          >
            <div className="h-12 w-12 rounded-lg bg-destructive/10 flex items-center justify-center mb-4 group-hover:bg-primary/10 transition-colors">
              <point.icon className="h-6 w-6 text-destructive group-hover:text-primary transition-colors" />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{point.title}</h3>
            <p className="text-sm text-muted-foreground">{point.description}</p>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
